function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M14.264.293H3.529A3.385 3.385 0 00.148 3.674V14.41a3.385 3.385 0 003.381 3.381h10.735a3.385 3.385 0 003.381-3.38V3.673a3.385 3.385 0 00-3.381-3.38zm.97 2.017l.386-.002v2.966l-2.955.01-.01-2.966 2.579-.008zM6.399 7.246a3.079 3.079 0 012.498-1.284c1.027 0 1.937.508 2.496 1.284.365.506.583 1.125.583 1.796a3.084 3.084 0 01-3.08 3.08 3.083 3.083 0 01-3.08-3.08c0-.67.219-1.29.583-1.796zm9.541 7.163c0 .925-.752 1.676-1.676 1.676H3.529a1.678 1.678 0 01-1.676-1.676V7.246h2.611a4.759 4.759 0 00-.352 1.796 4.79 4.79 0 004.785 4.784 4.79 4.79 0 004.784-4.784 4.76 4.76 0 00-.353-1.796h2.612v7.163z",
  fill: "currentColor",
  fillRule: "evenodd"
})));